export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  // The result of a send MESSAGE_SENT announced, with the same requestId.
  MESSAGE_SEND_FINISHED: 'MESSAGE_SEND_FINISHED',
  // The server refused a reply carrying an AI draft (ai_draft_revoked).
  AI_DRAFT_REVOKED: 'AI_DRAFT_REVOKED',
  FETCH_LABEL_SUGGESTIONS: 'FETCH_LABEL_SUGGESTIONS',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  INSERT_CANNED_RESPONSE: 'insertCannedResponse',
  REPLY_BOX_MODE_CHANGE: 'replyBoxModeChange',
  CONVERSATION_LINKS_UPDATED: 'conversationLinksUpdated',
  PLATFORM_USER_LOADED: 'PLATFORM_USER_LOADED',
  BLUECHEW_USER_LOADED: 'BLUECHEW_USER_LOADED',
};
